import { render, staticRenderFns } from "./Belt.vue?vue&type=template&id=08e0bde7&scoped=true&"
import script from "./Belt.vue?vue&type=script&lang=js&"
export * from "./Belt.vue?vue&type=script&lang=js&"
import style0 from "./Belt.vue?vue&type=style&index=0&id=08e0bde7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e0bde7",
  null
  
)

export default component.exports